import {Navbar} from '../../molecules'

import './index.scss'

const NavbarHeader = (): JSX.Element => {
  return (
    <header>
      <Navbar />
    </header>
  )
}

export default NavbarHeader
